import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UserPlus,
  User,
  Briefcase
} from 'lucide-react';
import axios from 'axios'; // Import axios for making the API request
import '../styles/GlobalStyles.css';


const InstHeroComponent = () => {
  // State to store the job post count
  const [stats, setStats] = useState({
    jobPosts: 0,
    candidatesSaved: 0,
    candidatesInvited: 0,
    candidatesShortlisted: 0,
    candidatesSelected: 0,
    candidatesOnHold: 0
  });

  const navigate = useNavigate();

  // Fetch the stats from the API
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/institutionfilter/institution-stats`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        setStats(response.data);
      } catch (error) {
        console.error('Error fetching institution stats:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="global-font p-4 bg-gray-50">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {/* Job Post */}
        <div
          onClick={() => navigate('/manage-jobs')}
          className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center space-x-3">
            <Briefcase className="text-blue-500" />
            <span className="text-sm font-medium text-gray-700">Job Posts</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.jobPosts}</span>
        </div>

        {/* Candidates Saved */}
        <div
          onClick={() => navigate('/saved-candidates')}
          className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center space-x-3">
            <UserPlus className="text-green-500" />
            <span className="text-sm font-medium text-gray-700">Candidates Saved</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.candidatesSaved}</span>
        </div>

        {/* Candidates Invited */}
        <div
          onClick={() => navigate('/invited-candidates')}
          className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center space-x-3">
            <User className="text-yellow-500" />
            <span className="text-sm font-medium text-gray-700">Candidates Invited</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.candidatesInvited}</span>
        </div>

        {/* Candidates Shortlisted */}
        {/* <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md opacity-75">
          <div className="flex items-center space-x-3">
            <UserCheck className="text-indigo-500" />
            <span className="text-sm font-medium text-gray-700">Candidates Shortlisted</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.candidatesShortlisted}</span>
        </div> */}

        {/* Candidates Selected */}
        {/* <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md opacity-75">
          <div className="flex items-center space-x-3">
            <User className="text-purple-500" />
            <span className="text-sm font-medium text-gray-700">Candidates Selected</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.candidatesSelected}</span>
        </div> */}

        {/* Candidates On Hold */}
        {/* <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-md opacity-75">
          <div className="flex items-center space-x-3">
            <PauseCircle className="text-red-500" />
            <span className="text-sm font-medium text-gray-700">Candidates On Hold</span>
          </div>
          <span className="text-2xl font-bold text-gray-800">{stats.candidatesOnHold}</span>
        </div> */}
      </div>
    </div>
  );
};

export default InstHeroComponent;
